import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Breadcrumb, Heading } from 'vet-bones/design-system/components';

import { Loading } from 'src/ui/components/Loading';
import { NotFound } from 'src/ui/components/NotFound';
import {
  LAUNCHPAD_SDU_DASHBOARD_BREADCRUMB_UNITS,
  LAUNCHPAD_SDU_DASHBOARD_HEADING,
} from 'src/ui/constants/testIds';
import { SduDashboardBody } from 'src/ui/containers/sdu-dashboard/SduDashboardBody';
import { SduEndpointActionMenu } from 'src/ui/containers/sdu-dashboard/SduEndpointActionMenu';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { useSavedConnectionsQuery } from 'src/ui/graph/types';
import * as copy from 'src/ui/templates/copy';

export const LaunchpadSduDashboardEndpoint: React.VFC = () => {
  const history = useHistory();
  const { index } = useParams<{ index: string }>();

  const { data, isLoading } = useSavedConnectionsQuery(graphQLClient, {});

  const connection = React.useMemo(
    () =>
      data?.listConnections?.find(
        (connection) => connection?.index === Number(index)
      ) ?? null,
    [data, index]
  );

  if (isLoading) {
    return <Loading />;
  }

  if (!connection) {
    return <NotFound />;
  }

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading
            size="xl"
            testId={LAUNCHPAD_SDU_DASHBOARD_HEADING}
            weight="semibold"
          >
            {copy.components.sduDashboard.title}
          </Heading>
          <Breadcrumb
            items={[
              {
                id: 'units',
                onClick: () => history.push('/units'),
                testId: LAUNCHPAD_SDU_DASHBOARD_BREADCRUMB_UNITS,
                text: copy.components.sduDashboard.title,
              },
              {
                id: 'units-endpoint',
                text: connection.name,
              },
            ]}
          />
        </div>
        <div className="organization-dashboard-header-actions">
          <SduEndpointActionMenu connection={connection} />
        </div>
      </div>

      <SduDashboardBody connectionId={connection.id} />
    </div>
  );
};
